import { safeJsonParse } from './safe-json-parse';
export var toSafeUIData = function (uiDataAsString, defaultValue) {
    var uiData = safeJsonParse(uiDataAsString);
    if (uiData === null || uiData === undefined) {
        uiData = defaultValue || {
            currentStep: 0,
            totalSteps: 1,
            stepStates: ['warning']
        };
    }
    return uiData;
};
export var toSafeSelectedProducts = function (environmentRequest, defaultValue) {
    var selectedProducts = safeJsonParse(environmentRequest === null || environmentRequest === void 0 ? void 0 : environmentRequest.infrastructure.properties._selectedProducts);
    if (selectedProducts === null || selectedProducts === undefined) {
        selectedProducts =
            defaultValue ||
                defaultSelectedProducts((environmentRequest === null || environmentRequest === void 0 ? void 0 : environmentRequest.products) || []);
    }
    return selectedProducts;
};
var defaultSelectedProducts = function (products) {
    return products.map(function (p) { return ({
        id: p.id,
        selectedDeploymentType: '',
        selectedAuthenticationType: '',
        selectedVersion: p.version,
        selected: true,
        type: p.properties.isImport === 'true' ? 'import' : 'new',
        sizes: {},
        description: '',
        detailsHref: '',
        errorMessage: '',
        productVersions: []
    }); });
};
